import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;

export const getConversations = (filter = {}) => {
  return axios.get(`${apiUrl}/admin/conversations`, { params: filter });
};

export const getConversation = (id) => {
  return axios.get(`${apiUrl}/admin/conversations/${id}`, {
    params: { include: ["user", "readByAdmin"] },
  });
};

export const getMessages = (conversationId, filter = {}) => {
  return axios.get(`${apiUrl}/admin/conversations/${conversationId}/messages`, {
    params: filter,
  });
};

export const sendMessage = (conversationId, content) => {
  return axios.post(
    `${apiUrl}/admin/conversations/${conversationId}/messages`,
    { content }
  );
};

export const updateConversationStatus = (conversationId, status) => {
  return axios.patch(`${apiUrl}/admin/conversations/${conversationId}/status`, {
    status,
  });
};

export const markAsRead = (messageId) => {
  // This might not be needed if fetching messages marks them as read,
  // or if the status update handles it.
  // Implementing purely based on plan description.
  return axios.patch(`${apiUrl}/admin/messages/${messageId}/read`);
};

export const markConversationAsRead = (conversationId) => {
  return axios.patch(
    `${apiUrl}/admin/conversations/${conversationId}/mark-read`
  );
};

export const getUnreadConversationCounts = () => {
  return axios.get(`${apiUrl}/admin/conversations/unread-counts`);
};

export const conversationStatuses = [
  { id: 0, label: "open", name: "Nyitott" },
  { id: 1, label: "closed", name: "Lezárt" },
  { id: 2, label: "snoozed", name: "Alvó" },
];
